<template>
  <div class="pw-tool">
    <div class="editor-pane" v-if="!loading && !done">
      <div class="pane-header">
        <span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.PdfToWord.upload') }}</span>
        <span class="pane-hint">{{ $t('tool.PdfToWord.uploadHint') }}</span>
      </div>
      <el-upload ref="upload" drag action="#" :auto-upload="false" :on-change="handleFile" :limit="1" accept=".pdf" :file-list="fileList">
        <i class="el-icon-upload" style="font-size:42px;color:#c0c4cc;" />
        <div class="el-upload__text">{{ $t('tool.PdfToWord.dropText') }}<em>{{ $t('tool.PdfToWord.clickUpload') }}</em></div>
      </el-upload>
      <div style="text-align:center;margin-top:12px;" v-if="file">
        <el-button type="primary" size="small" @click="convert">{{ $t('tool.PdfToWord.btnConvert') }}</el-button>
      </div>
    </div>

    <div class="editor-pane" v-if="loading">
      <div class="pane-header"><span class="pane-dot" style="background:#e6a23c;box-shadow:0 0 6px rgba(230,162,60,.4);" /><span class="pane-label">{{ $t('tool.PdfToWord.title') }}</span></div>
      <div style="text-align:center;padding:20px 0;">
        <i class="el-icon-loading" style="font-size:32px;color:#4e7cff;" />
        <p style="margin-top:10px;font-size:13px;color:#8892a6;">{{ $t('tool.PdfToWord.processing') }}</p>
      </div>
    </div>

    <div class="editor-pane" v-if="done">
      <div class="pane-header"><span class="pane-dot output-dot" /><span class="pane-label">{{ $t('tool.PdfToWord.title') }}</span></div>
      <div style="text-align:center;padding:14px 0;">
        <i class="el-icon-success" style="font-size:40px;color:#67c23a;" />
        <p style="margin:12px 0;font-size:15px;color:#303133;font-weight:500;">{{ $t('tool.PdfToWord.generated') }}</p>
        <div style="display:flex;gap:12px;justify-content:center">
          <a :href="downloadUrl" download="converted.docx" class="el-button el-button--primary el-button--small" style="text-decoration:none;color:#fff">{{ $t('tool.PdfToWord.download') }}</a>
          <el-button size="small" @click="reset">{{ $t('tool.PdfToWord.reupload') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertPdfToWord } from '@/api/site'
export default {
  name:'PdfToWordTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({file:null,fileList:[],loading:false,done:false,downloadUrl:''}),
  methods:{
    handleFile(f){if(f.size>20*1024*1024){this.$message.error(this.$t('tool.PdfToWord.maxSize'));return}this.file=f.raw;this.fileList=[f]},
    async convert(){if(!this.file)return;this.loading=true;try{const fd=new FormData();fd.append('file',this.file);const res=await convertPdfToWord(fd);this.downloadUrl=res.data;this.done=true}catch(e){this.$message.error(this.$t('tool.PdfToWord.convertFail')+': '+(e.message||''))};this.loading=false},
    reset(){this.done=false;this.file=null;this.fileList=[];this.downloadUrl=''},
    doAction(a){if(a==='clear')this.reset()}
  }
}
</script>

<style scoped>
.pw-tool { display:flex;flex-direction:column;gap:16px; }
.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; min-width:0; overflow:hidden; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:12px; flex-wrap:wrap; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.output-dot { background:#43e97b;box-shadow:0 0 6px rgba(67,233,123,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.pane-hint { font-size:11px;color:#b0b8c4;margin-left:auto; white-space:nowrap; }
.editor-pane ::v-deep .el-upload { width:100%; }
::v-deep .el-upload-dragger { max-width:100%; width:100%; box-sizing:border-box;  display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:170px; }



@media (max-width: 640px) {
  .editor-pane { padding: 12px 14px; }
  .pane-hint { display: none; }
  .editor-pane ::v-deep .el-upload-dragger { min-height: 140px; padding: 20px 12px; }
  .editor-pane ::v-deep .el-upload__text { font-size: 12px; }
}

</style>
